import { render, staticRenderFns } from "./good-component.vue?vue&type=template&id=6106a920&scoped=true&"
import script from "./good-component.vue?vue&type=script&lang=js&"
export * from "./good-component.vue?vue&type=script&lang=js&"
import style0 from "./good-component.vue?vue&type=style&index=0&lang=stylus&rel=stylesheet%2Fstylus&"
import style1 from "./good-component.vue?vue&type=style&index=1&id=6106a920&lang=stylus&rel=stylesheet%2Fstylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106a920",
  null
  
)

export default component.exports